import automaticResponse from '@/api/automaticResponse'

const state = () => ({
  all: [],
  automaticResponse: {},
  grouped: null,
  deleted: null,
  allFromGroup: [],
  allToGroup: [],
  uploadXlsFile: null,
  uploadXlsFileError:null,
})

const getters = {}

const actions = {
  async getAutomaticResponses ({ commit }, params) {
    const result = await automaticResponse.getAll(params)
    commit('setAutomaticResponses', result.data)
  },

  async getAutomaticResponseFromGroup ({ commit }, params) {
    const result = await automaticResponse.getAll(params)
    commit('setAutomaticResponseFromGroup', result.data)
  },

  async getAutomaticResponseToGroup ({ commit }, params) {
    const result = await automaticResponse.getAll(params)
    commit('setAutomaticResponseToGroup', result.data)
  },

  async getAutomaticResponse ({ commit }, id) {
    const result = await automaticResponse.getOne(id)
    commit('setAutomaticResponse', result.data)
  },

  async create ({ commit }, data) {
    const result = await automaticResponse.create(data)
    commit('setAutomaticResponse', result.data)
  },

  async update ({ commit }, { id, data }) {
    const result = await automaticResponse.update(id, data)
    commit('setAutomaticResponse', result.data)
  },

  async delete ({ commit }, id) {
    const result = await automaticResponse.deleteOne(id)
    commit('setDeleted', result.data)
  },

  async group ({ commit }, data) {
    const result = await automaticResponse.group(data)
    commit('setGrouped', result.data)
  },
  async uploadXlsFile({ commit }, params) {
    try{
      const result = await automaticResponse.uploadXlsFile(params);
      commit('setUploadXlsFile', result.data);
    }
    catch(e){
      commit('setUploadXlsFileError', e);
    }
    
  },
}

const mutations = {
  setAutomaticResponse (state, automaticResponse) {
    state.automaticResponse = automaticResponse
  },
  setAutomaticResponses (state, automaticResponses) {
    state.all = automaticResponses
  },
  setAutomaticResponsesFromGroup (state, automaticResponses) {
    state.allFromGroup = automaticResponses
  },
  setAutomaticResponsesToGroup (state, automaticResponses) {
    state.allToGroup = automaticResponses
  },
  setGrouped (state, result) {
    state.grouped = result
  },
  setDeleted (state, result) {
    state.deleted = result
  },
  setUploadXlsFile(state, data){
    state.uploadXlsFile = data;
  },
  setUploadXlsFileError(state, e){
    state.uploadXlsFileError = e;
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}